import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import MetaTags from "./index";
import { useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const tags = {
  index: {
    vod: {
      title: "お問い合わせ | SPOOX(スプークス)",
      keywords: "SPOOX,スプークス,動画配信,見放題,レンタル",
      description: "SPOOX(スプークス)に関するお問い合わせはこちらから。SPOOX(スプークス)では、スポーツや映画やアニメなど、様々な動画を配信中です。",
      og: {
        type: "article"
      }
    }
  },
  confirm: {
    vod: {
      title: "お問い合わせ内容確認 | SPOOX(スプークス)",
      keywords: "SPOOX,スプークス,動画配信,見放題,レンタル",
      description: "お問い合わせ内容確認。SPOOX(スプークス)では、スポーツや映画やアニメなど、様々な動画を配信中です。",
      og: {
        type: "article"
      }
    }
  },
  complete: {
    vod: {
      title: "お問い合わせ完了 | SPOOX(スプークス)",
      keywords: "SPOOX,スプークス,動画配信,見放題,レンタル",
      description: "お問い合わせ完了。SPOOX(スプークス)では、スポーツや映画やアニメなど、様々な動画を配信中です。",
      og: {
        type: "article"
      }
    }
  }
};
export default function InquiryMetaTags(_ref) {
  let {
    action
  } = _ref;
  const props = tags[action]["vod"];
  const noindex = useMemo(() => {
    if (action === "confirm" || action === "complete") return "noindex";
    return null;
  }, [action]);
  return /*#__PURE__*/_jsx(MetaTags, _objectSpread(_objectSpread({}, props), {}, {
    robots: noindex
  }));
}